export default {"src":"/_next/static/media/check-filled.933b20fa.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};